export default {
  primaryBlue: "#253F6E",
  secondaryBlue: "#6598CD",
  lightBlue: "rgba(220,234,247,1)",
};
